import VS from 'constants/ValidationShema';
import {VARIANT_CODE} from "components/popup/newCriteria/constants/criteria.variants";
import {PriceType} from "constants/PriceTypes";
import VatType from "constants/VatType";
import Tr from "translations/Translations";

const criterionValidation = (criterion, priceType, criterions) => {
    if (criterion.criterium.disabled)
        return VS.any();
    let shape = {};
    switch (criterion.criterium.uiType) {
        case VARIANT_CODE.NUMBER:
        case VARIANT_CODE.INTERVAL:
            shape.value = VS.string();
            break;
        case VARIANT_CODE.PRICE: {
            const predefined = !!criterion.criterium.offerValuesPredefined;
            const isValidPrice = (val) => predefined ? parseFloat(val) >= 0 : parseFloat(val) > 0;

            switch (priceType) {
                case PriceType.NET:
                case PriceType.NET_VAT:
                    shape.value = VS.string().test('more_than_0', Tr('v_number_min_0'), () => {
                        return isValidPrice(criterion.value)
                    })
                    break;
                case PriceType.NET_GROSS:
                    shape.value = VS.string().test('more_than_0', Tr('v_number_min_0'), () => {
                        return isValidPrice(criterion.value)
                    })
                    shape.grossValue = VS.any().when("vatType",
                        {
                            is: (vatType) => vatType === VatType.MIXED,
                            then: VS.any().test('gross_less', Tr('gross_less'), () => {
                                const gVal = parseFloat(criterion.grossValue);
                                return isValidPrice(gVal) && gVal>= parseFloat(criterion.value)
                            }),
                            otherwise: VS.any()
                        }
                    )
                    break;
                case PriceType.GROSS:
                case PriceType.GROSS_VAT:
                    shape.grossValue = VS.string().test('more_than_0', Tr('v_number_min_0'), () => {
                        return isValidPrice(criterion.grossValue)
                    })
                    break;
                default:
            }

            switch (priceType) {
                case PriceType.NET_VAT:
                case PriceType.NET_GROSS:
                case PriceType.GROSS_VAT:

                    shape.vatType = VS.string()
                    shape.vatValue = VS.any().when('vatType',
                        {
                            is: (val) => (val === VatType.OTHER || val === VatType.STANDARD),
                            then: VS.decimalNumber("")
                        }
                    )
                    break;
                default:
            }

            if (criterion.quantity !== null && criterion.quantity !== undefined) {
                const quantityShape = {
                    value: VS.numberMin0(),
                    uom: VS.string()
                };
                if (!!criterion.criterium.baseItemId) {
                    quantityShape.uom = VS.string().test('offer_option_uom_must_match_base_item', Tr('offer_option_uom_must_match_base_item'), () => {
                       const baseCriterion = criterions.filter(c => c.criterium.identity === criterion.criterium.baseItemId)[0];
                       const quantity = !!baseCriterion.quantity ? baseCriterion.quantity : baseCriterion.criterium.quantity;
                       return quantity.uom === criterion.quantity.uom;
                    });
                } else if (!!criterion.criterium.optionalItemId) {
                    quantityShape.uom = VS.string().test('offer_base_uom_must_match_option_item', Tr('offer_base_uom_must_match_option_item'), () => {
                        const optionCriterion = criterions.filter(c => c.criterium.identity === criterion.criterium.optionalItemId)[0];
                        const quantity = !!optionCriterion.quantity ? optionCriterion.quantity : optionCriterion.criterium.quantity;
                        return quantity.uom === criterion.quantity.uom;
                    });
                }
                shape.quantity = VS.object(quantityShape);
            }

            shape.parameterOffers =  VS.arrayOf(VS.object({offerValue: VS.string()}))

            break;
        }
        case VARIANT_CODE.YESNO:
        case VARIANT_CODE.LIST:
        case VARIANT_CODE.TEXT:
        default:
            shape.value = VS.string();
    }

    if (criterion.criterium.showComment) {
        shape.comment = VS.string()
    }


    return VS.object(shape)
}


export const offerValidation = VS.lazy(form => {
    return VS.object({
        consorciants: form.consorciumOnPosition ?  VS.arrayRequired("consorciant_required") : VS.any(),
        conditions: VS.arrayOf(VS.lazy(criterion => criterionValidation(criterion, form.priceType))),
        criteriums: VS.arrayOf(VS.lazy(criterion => criterionValidation(criterion, form.priceType))),
        parameters: VS.arrayOf(VS.lazy(criterion => criterionValidation(criterion, form.priceType))),
        itemOffers: VS.arrayOf(VS.lazy(criterion => criterionValidation(criterion, form.priceType, form.itemOffers)))
    })
});
